import { MenuItem, Select } from '@mui/material';
import { IconButton } from '@material-ui/core';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { getPaginationNumber } from '../functions/general';

const row_page = [10, 25, 50, 100];

export const Pagination = ({ 
	handleChangeMenu, 
	pageDetail,
	onClickNavigation,
}) => {
	return (
		<div className="pagination">
			<div style={{ display: "flex", alignItems: "center", marginRight: "5px" }}>
				<div style={{ minHeight: "25px", marginRight: "5px" }}>Rows per page: </div>
				<div>
					<Select
						value={pageDetail.limit}
						onChange={handleChangeMenu}
						displayEmpty
						inputProps={{ 'aria-label': 'Without label' }}
						MenuProps={{ sx: { '.MuiList-root': { display: 'flex', flexDirection: 'column' }} }}
						sx={{ paddingLeft: '8px', '.MuiOutlinedInput-input': { padding: '0' }, '.MuiOutlinedInput-notchedOutline': { border: '0' }, '.MuiSelect-select': { minHeight: 'unset !important' } }}
					>
						{row_page.map((value, key) => {
							return <MenuItem key={key} value={value} sx={{display: 'block'}}>{value}</MenuItem>
						})}
					</Select>
				</div>
			</div>
			<div style={{ display: "flex", alignItems: "center" }}>
				<div>
					<p>{getPaginationNumber("start", pageDetail)} - {getPaginationNumber("end", pageDetail)} of {pageDetail.total}</p>
				</div>
				<div style={{ marginLeft: '10px' }}>
					<IconButton className="button-pagination" aria-label="naviate-before" disabled={pageDetail.page === 1} onClick={() => onClickNavigation(-1)} >
						<NavigateBeforeIcon />
					</IconButton>
					<IconButton className="button-pagination" aria-label="naviate-before" disabled={pageDetail.page === pageDetail.totalPages} onClick={() => onClickNavigation(1)} >
						<NavigateNextIcon />
					</IconButton>
				</div>
			</div>
		</div>
	)
}